module.exports = __webpack_public_path__ + "f47cf185924c89cc433987c532e8ef87.png";